module.exports = "/_next/static/images/a119972b6aae89ef885f4745950e8a2a-fees-right.jpg.webp";